import { Box, Grid } from '@mui/material';
import { Fragment } from 'react';
import { font700Sx } from '../../styles/Global.style';
import { Text } from '../Text/Text';
import {
  challengeDetailsContainerSx,
  gridContainerSx,
} from './ChallengeDetails.style';

export const ChallengeDetails = ({ detailsArray }) => (
  <Box component="div" sx={gridContainerSx}>
    <Grid container rowSpacing={1} sx={challengeDetailsContainerSx}>
      {detailsArray.map((item, index) => (
        <Fragment key={`detail-${index}`}>
          <Grid item xs={6}>
            <Text text={item.label} sx={font700Sx} />
          </Grid>
          <Grid item xs={6}>
            <Text text={item.value} />
          </Grid>
        </Fragment>
      ))}
    </Grid>
  </Box>
);
